module.exports = __webpack_public_path__ + "img/varangkana.677c7a17.jpg";